import { render, staticRenderFns } from "./PointEmptyDefaultLayout.vue?vue&type=template&id=218071cb&scoped=true"
import script from "./PointEmptyDefaultLayout.vue?vue&type=script&lang=js"
export * from "./PointEmptyDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218071cb",
  null
  
)

export default component.exports